<div class="help-glossary-container container-default bg-white">
  <common-jumbotron
    header="Rental Terms Index"
    subHeader="A complete list of everything you need to know about renting with Rubbl"
    imagePath="/pubweb/marketplace/images/backgrounds/glossary-jumbotron.jpg"
  ></common-jumbotron>
  <div class="container mt-5">
    <!-- <a [routerLink]="['/help/listing-terms']">View Listing Terms</a> -->
    <div class="bb-light my-4"></div>
    <common-glossary [glossarySections]="glossarySections"></common-glossary>
  </div>
</div>
<common-footer></common-footer>
